module.exports = __webpack_public_path__ + "img/google-cloud.4629dea4.svg";